import { Modal, Form, Row, Col, Input, Button } from "antd";
import { useModalTipos } from "../../../hooks/useModalTipos";

interface IModalCodigos {
  openModal: boolean;
  setOpenModal: Function;
}

export const ModalTipos = ({
  openModal,
  setOpenModal
}: IModalCodigos): any => {
  const {
    actualizarCodigo,
    setCodigoPropuesta,
    codigoPropuesta,
    tipoP,
    setTipoP,
    numeroDocumento,
    setNumeroDocumento
  } = useModalTipos()

  const fields = [
    { name: "codigoPropuesta", value: codigoPropuesta },
    { name: "numeroDocumento", value: numeroDocumento },
    { name: "tipoP", value: tipoP },
  ];

  const handleInputChangeCodigo = (e) => {
    setCodigoPropuesta(e.target.value);
  };

  const handleInputChangeId = (e) => {
    setNumeroDocumento(e.target.value);
  };

  const handleInputChangeType = (e) => {
    setTipoP(e.target.value);
  };

  // @ts-ignore
  return (
    <Modal
      maskStyle={{
        backgroundColor: "rgba(31,174,239,0.8)",
        borderRadius: "6px",
      }}
      title="Gestionar tipo de participantes"
      visible={openModal}
      onCancel={() => setOpenModal(!openModal)}
      width={window.innerWidth * 0.5}
      footer={
        <Row justify="end" gutter={[24, 24]}>
          <Col>
            <Button
              className="button-gray-ghost"
              onClick={() => window.location.reload()}
            >
              Cerrar
            </Button>
          </Col>
          <Col className="justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              form="modalCodigos"
            >
              Actualizar tipo participante
            </Button>
          </Col>
        </Row>
      }
    >
      <Form
        fields={fields}
        name="modalCodigos"
        onFinish={() => actualizarCodigo()}
      >
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="codigoPropuesta"
              rules={[{ required: true, message: "" }]}
            >
              <Input onChange={handleInputChangeCodigo} placeholder="Código de propuesta" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="numeroDocumento"
              rules={[{ required: true, message: "" }]}
            >
              <Input onChange={handleInputChangeId} placeholder="Número de documento" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="tipoP"
              rules={[{ required: true, message: "" }]}
            >
              <Input onChange={handleInputChangeType} placeholder="Tipo de participante: 1, 2 o 3" />
            </Form.Item>
          </Col>
          <br />
          { tipoP && (
            <div>
              Se actualiza el tipo de participante con propuesta <span style={{fontWeight: 'bold'}}>{codigoPropuesta}</span> con el tipo #: <span style={{fontWeight: 'bold'}}>{setTipoP}</span>
            </div>
          )}
        </Row>
      </Form>
    </Modal>
  );
};
